/**
 * View component for /siteLocations
 *
 * Generic siteLocation list view. Defaults to 'all' with:
 * this.props.dispatch(siteLocationActions.fetchListIfNeeded());
 *
 * NOTE: See /product/views/ProductList.js.jsx for more examples
 */

// import primary libraries
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';

// import actions
import * as siteLocationActions from '../siteLocationActions';

// import global components
import Base from "../../../global/components/BaseComponent.js.jsx";
import Breadcrumbs from '../../../global/components/routing/Breadcrumbs.js.jsx';
import Pagination from "../../../global/components/helpers/Pagination.js.jsx";
import { SearchInput, SelectFromObject } from '../../../global/components/forms';

// import siteLocation components
import SiteLocationListItem from '../components/SiteLocationListItem.js.jsx';

// import utilities
import filterUtils from '../../../global/utils/filterUtils';

// import siteLocation css modules
import siteLocationStyles from '../siteLocationModuleStyles.css';

class AdminSiteLocationList extends Base {
  constructor(props) {
    super(props);
    this.state = {
      perPage: 50
      , queryText: this.props.query || ''
    };
    this._bind(
      '_handleQuery'
      , '_handleSetPagination'
      , '_handleSort'
      , '_resetPagination'
      , '_setPerPage'
    );
  }

  componentDidMount() {
    const { dispatch } = this.props;
    // fetch a list of your choice
    dispatch(siteLocationActions.fetchListIfNeeded()); // defaults to 'all'
    dispatch(siteLocationActions.setFilter({query: '', sortBy: 'name'}));
    dispatch(siteLocationActions.setPagination({page: 1, per: 50}));
  }

  _handleSort(sortBy) {
    const { dispatch, match, siteLocationList } = this.props;
    let newFilter = siteLocationList.filter;
    if(siteLocationList.filter.sortBy && siteLocationList.filter.sortBy.indexOf("-") < 0) {
      sortBy = "-" + sortBy;
    } else {
      sortBy = sortBy.substring(0)
    }
    newFilter.sortBy = sortBy;
    dispatch(siteLocationActions.setFilter(newFilter));
  }

  _handleSelectSort(e) {
    const { dispatch, match, siteLocationList } = this.props;
    let newFilter = siteLocationList.filter;
    let sortBy = e.target.value;
    if(siteLocationList.filter.sortBy && siteLocationList.filter.sortBy.indexOf("-") < 0) {
      sortBy = "-" + sortBy;
    } else {
      sortBy = sortBy.substring(0)
    }
    newFilter.sortBy = sortBy;
    dispatch(siteLocationActions.setFilter(newFilter));
  }

  _resetPagination() {
    const { dispatch, match } = this.props;
    dispatch(siteLocationActions.setPagination({
      page: 1,
      per: parseInt(this.state.perPage)
    }));
  }

  _setPerPage(per) {
    const { dispatch, match, siteLocationList } = this.props;
    let newPagination = siteLocationList.pagination;
    newPagination.per = parseInt(per);
    newPagination.page = 1;
    dispatch(siteLocationActions.setPagination(newPagination));
    this.setState({perPage: per});
  }

  _handleSetPagination(newPagination) {
    const { dispatch, match } = this.props;
    dispatch(siteLocationActions.setPagination(newPagination));
  }

  _handleQuery(e) {
    const { dispatch, match, siteLocationList } = this.props;
    // always defaulting the page to page 1 so we can see our results
    let pagination = {};
    pagination.page = 1;
    pagination.per = siteLocationList.pagination.per;
    this._handleSetPagination(pagination);
    // continue query logic
    dispatch(siteLocationActions.setFilter({
      query: e.target.value.toLowerCase()
      , sortBy: siteLocationList.filter.sortBy
    }));
  }

  render() {
    const {
      location
      , match
      , paginatedList
      , sortedList
      , siteLocationList
      , siteLocationStore
    } = this.props;

    /**
     * NOTE: isEmpty is is usefull when the component references more than one
     * resource list.
     */

    const isEmpty = !siteLocationList || !siteLocationList.items || siteLocationList.didInvalidate;
    const sortedEmpty = sortedList.length === 0;

    return (
        <div className="flex">
          <section className="section">
            <div className="yt-container">
              <h1> Site/Team Locations
                <Link className="yt-btn create u-pullRight" to={'/admin/site-locations/new'}>
                  <img className="-icon" src={'/img/create-white.png'}></img>
                </Link>
              </h1>
              <hr/>
              { isEmpty ?
                (siteLocationList && siteLocationList.isFetching ? <h2>Loading...</h2> : <h2>Empty.</h2>)
                :
                <div style={{ opacity: siteLocationList.isFetching ? 0.5 : 1 }}>
                  <div className="yt-toolbar">
                    <div className="yt-tools space-between">
                      <div className="search">
                        <SearchInput
                          name="query"
                          value={siteLocationList.filter.query}
                          change={this._handleQuery}
                          placeholder="Search..."
                          required={false}
                        />
                      </div>
                      {/* <div className="sort-by">
                        <SelectFromObject
                          change={this._handleSelectSort}
                          display={'name'}
                          filterable={true}
                          label="Sort by"
                          name="sortBy"
                          objects={[
                            {name:'Name a-z', type: 'name'}
                            , {name:'Name z-a', type: '-name'}
                            , {name: 'Street address', type: 'address'}
                            , {name: 'City a-z', type: 'city' }
                            , {name: 'City z-a', type: '-city' }
                          ]}
                          selected={siteLocationList.filter.sortBy}
                          value={'type'}
                        />
                      </div> */}
                    </div>
                  </div>
                  <div className="yt-row space-between">
                    { siteLocationList.filter && siteLocationList.filter.query && siteLocationList.filter.query.length > 0 ?
                      <span>Filtered Site/Team Locations &mdash; {sortedList.length} of {Object.keys(siteLocationList.items).length}</span>
                      :
                      <span>All Site/Team Locations &mdash; {Object.keys(siteLocationList.items).length}</span>
                    }
                    <div className="per-page-select">
                      <label>Show per page: </label>
                      <select
                        name="numPerPage"
                        onChange={(e) => this._setPerPage(e.target.value)}
                        value={this.state.perPage}
                      >
                        <option value={25}> 25 </option>
                        <option value={50}> 50 </option>
                        <option value={100}> 100 </option>
                      </select>
                    </div>
                  </div>
                  <div className="content-container">
                    <div className="-site-location-list">
                      {paginatedList.map((siteLocation, i) =>
                        <SiteLocationListItem
                          key={siteLocation._id + i}
                          siteLocation={siteLocation}
                          url={`${match.url}/${siteLocation._id}`}
                        />
                      )}
                    </div>
                    { sortedEmpty ?
                      null
                      :
                      <Pagination
                        pagination={siteLocationList.pagination}
                        setPagination={this._handleSetPagination}
                        totalPages={ Math.floor(sortedList.length / siteLocationList.pagination.per) + 1}
                      />
                    }
                  </div>
                  {/* <div className="content-container">
                    <div className="yt-row space-between">
                      { siteLocationList.filter && siteLocationList.filter.query && siteLocationList.filter.query.length > 0 ?
                        <span>Filtered Site/Team Locations &mdash; {sortedList.length} of {Object.keys(siteLocationList.items).length}</span>
                        :
                        <span>All Site/Team Locations &mdash; {Object.keys(siteLocationList.items).length}</span>
                      }
                      <div className="per-page-select">
                        <label>Show per page: </label>
                        <select
                          name="numPerPage"
                          onChange={(e) => this._setPerPage(e.target.value)}
                          value={this.state.perPage}
                          >
                          <option value={25}> 25 </option>
                          <option value={50}> 50 </option>
                          <option value={100}> 100 </option>
                        </select>
                      </div>
                    </div>
                    <div className="table-wrapper">
                      <table className="yt-table striped">
                        <caption>
                          { siteLocationList.filter && siteLocationList.filter.query && siteLocationList.filter.query.length > 0 ?
                            <span>Filtered Site/Team Locations &mdash; {sortedList.length} of {Object.keys(siteLocationList.items).length}</span>
                            :
                            <span>All Site/Team Locations &mdash; {Object.keys(siteLocationList.items).length}</span>
                          }
                          <div className="per-page-select u-pullRight">
                            <label>Show per page: </label>
                            <select
                              name="numPerPage"
                              onChange={(e) => this._setPerPage(e.target.value)}
                              value={this.state.perPage}
                              >
                              <option value={25}> 25 </option>
                              <option value={50}> 50 </option>
                              <option value={100}> 100 </option>
                            </select>
                          </div>
                        </caption>
                        <thead>
                          <tr>
                            <th className="sortable" onClick={()=> this._handleSort('name')}>
                              Name
                              {siteLocationList.filter.sortBy === 'name' ?
                                <i className="ion ion-ios-arrow-down" />
                                : siteLocationList.filter.sortBy === '-name' ?
                                <i className="ion ion-ios-arrow-up" />
                                : null
                              }
                            </th>
                            <th className="_30 sortable" onClick={()=> this._handleSort('updated')}>
                              Last Modified
                              {siteLocationList.filter.sortBy === 'updated' ?
                                <i className="ion ion-ios-arrow-down" />
                                : siteLocationList.filter.sortBy === '-updated' ?
                                <i className="ion ion-ios-arrow-up" />
                                : null
                              }
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {
                            paginatedList.map((siteLocation, i) =>
                            <SiteLocationListItem
                              key={siteLocation._id + i}
                              siteLocation={siteLocation}
                            />
                          )
                        }
                      </tbody>
                    </table>
                    { sortedEmpty ?
                      null
                      :
                      <Pagination
                        pagination={siteLocationList.pagination}
                        setPagination={this._handleSetPagination}
                        totalPages={ Math.floor(sortedList.length / siteLocationList.pagination.per) + 1}
                        />
                    }
                  </div>
                  </div> */}
                </div>
              }
            </div>
          </section>
        </div>
    )
  }
}

AdminSiteLocationList.propTypes = {
  dispatch: PropTypes.func.isRequired
}

const mapStoreToProps = (store) => {
  /**
   * NOTE: Yote refer's to the global Redux 'state' as 'store' to keep it mentally
   * differentiated from the React component's internal state
   */
  const siteLocationStore = store.siteLocation;
  const siteLocationList = siteLocationStore.lists ? siteLocationStore.lists.all : null;
  let sortedList = [];
  let paginatedList = [];
  let filteredByQuery = [];
  if (siteLocationList) {

    const pagination = siteLocationList.pagination;
    const filter = siteLocationList.filter;
    const query = filter ? filter.query : '';
    const sortBy = filter ? filter.sortBy : 'email';

    // FILTER BY QUERY
    let queryTestString = ("" + query).toLowerCase().trim();
    // queryTestString = queryTestString.replace(/[^a-zA-Z0-9]/g,''); // replace all non-characters and numbers
    filteredByQuery = siteLocationList && siteLocationList.items ? siteLocationList.items.filter((siteLocationId) => {
      return filterUtils.filterSiteLocation(queryTestString, siteLocationStore.byId[siteLocationId]);
    }) : []

    // SORT THE LIST
    sortedList = filteredByQuery.map((item) => {
      let newItem = siteLocationStore.byId[item];
      return newItem;
    });
    switch(sortBy) {
      case 'name':
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['asc']);
        break;
      case '-name':
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['desc']);
        break;
      case 'updated':
        sortedList = _.orderBy(sortedList, [item => item.updated], ['asc']);
        break;
      case '-updated':
        sortedList = _.orderBy(sortedList, [item => item.updated], ['desc']);
        break;
      default:
        sortedList = _.orderBy(sortedList, [item => item.name.toLowerCase()], ['asc']);
    }

    // apply pagination
    let start = pagination ? (pagination.page - 1) * pagination.per : 1;
    let end = pagination ? start + pagination.per : 0;
    paginatedList = _.slice(sortedList, start, end);

  }
  return {
    paginatedList
    , sortedList
    , siteLocationList
    , siteLocationStore
  }
}

export default withRouter(
  connect(
    mapStoreToProps
  )(AdminSiteLocationList)
);



// WEBPACK FOOTER //
// modules/siteLocation/views/AdminSiteLocationList.js.jsx